import styled, {css, keyframes} from 'styled-components';
import React, {useState} from 'react';
import {Link} from 'gatsby';
import CustomLink from './CustomLink';

// styled components

const buttonAnimPrime = (color = 'red') => keyframes`
    0%{
      width: 0;
      height: 0;
      border-top-color: ${color};
      border-right-color: transparent;
      border-bottom-color: transparent;
      border-left-color: transparent;
    }
    75%{
      width: calc(100% + 6px);
      height: 0;
      border-top-color: ${color};
      border-right-color: ${color};
      border-bottom-color: transparent;
      border-left-color: transparent;
    }
    100%{
      width: calc(100% + 6px);
      height: calc(100% + 6px);
      border-top-color: ${color};
      border-right-color: ${color};
      border-bottom-color: transparent;
      border-left-color: transparent;
    }
`;

const buttonAnimSecond = (color = 'red') => keyframes`
    0%{
      width: 0;
      height: 0;
      border-top-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
      border-left-color: transparent;
    }
    75%{
      width: calc(100% + 6px);
      height: 0;
      border-top-color: transparent;
      border-right-color: transparent;
      border-bottom-color: ${color};
      border-left-color: ${color};
    }
    100%{
      width: calc(100% + 6px);
      height: calc(100% + 6px);
      border-top-color: transparent;
      border-right-color: transparent;
      border-bottom-color: ${color};
      border-left-color: ${color};
    }
`;

export const SectionTitle = styled.h3`
  color: ${({color}) => color || '#fff'};
  font-family: 'RENNERBLACK', sans-serif;
  white-space: nowrap;
  font-size: 2.5rem;
  text-transform: uppercase;
  position: relative;
  display: inline;

  @media (max-width: 768px) {
    white-space: normal;
  }

  @media (max-width: 600px) {
    font-size: ${({jan, long}) => (jan || long ? '2rem' : '2.5rem')};
  }

  ${({Kalendarium}) =>
    Kalendarium &&
    css`
      @media (max-width: 1024px) {
        display: block;
        text-align: center;
      }
    `}

  @media (max-width: 470px) {
    font-size: ${({jan, long}) => (jan || long ? '1.5rem' : '2.2rem')};
  }

  @media (max-width: 380px) {
    font-size: ${({jan, long}) => (jan || long ? '1.3rem' : '1.7rem')};
  }

  &::before {
    content: '';
    display: block;
    width: 0;
    height: 0.4rem;
    background: ${({color}) => color || '#fff'};
    position: absolute;
    bottom: ${({jan}) => (jan ? '-0.1rem' : '-0.1rem')};
    left: ${({jan}) => (jan ? '1rem' : '0')};
    transition: width 0.7s;
  }

  &:hover::before {
    width: ${({jan}) => (jan ? 'calc(100% - 1rem)' : '100%')};
  }
`;

export const SectionText = styled.p`
  color: ${({color}) => color || '#fff'};
  font-family: 'LATOREGULAR';
  font-size: 0.83rem;
  line-height: 1.8;
  margin: ${({margin}) => margin};
  text-align: justify;
`;

export const ActionButton = styled(CustomLink)`
  padding: 0.3rem 1.1rem;
  font-family: 'LATOREGULAR';
  font-size: 1rem;
  position: relative;
  background: transparent;
  color: #fff;
  border: 3px solid #fff;
  text-transform: uppercase;
  cursor: pointer;
  text-decoration: none;
  //border-radius: 10px;

  &:before {
    content: '';
    position: absolute;
    top: -3px;
    left: -3px;
    width: 0;
    height: 0;
    background: transparent;
    border: 3px solid transparent;
    //border-radius: 10px;
  }

  &:hover:before {
    animation: ${({color}) => buttonAnimPrime(color)} linear 0.3s forwards;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: -3px;
    right: -3px;
    width: 0;
    height: 0;
    background: transparent;
    border: 3px solid transparent;
    //border-radius: 10px;
  }

  &:hover:after {
    animation: ${({color}) => buttonAnimSecond(color)} linear 0.3s 0.3s forwards;
  }
`;

// react components
